export default function (type, data, callback, dataType = 'json', param = null, errorCallback = null, defaultHeaders = null) {
  const getCurrentUrl = new URL(window.location.href);
  const $custom_loader = $('.custom-loader_load_more');
  
  if (defaultHeaders === null) {
    defaultHeaders = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json',
    }
  }

  $.ajax({
    url: '/wp-admin/admin-ajax.php',
    type: typeof type !== 'undefined' ? type : 'GET',
    dataType: dataType,
    data: data,
    headers: defaultHeaders,
    beforeSend: function () {
      if (typeof window.request !== 'undefined') {
        window.request.abort();
      }
    },
    success: function (response) {
      if (response.redirect_url !== undefined) {
        if (response.file_name !== undefined) {

          setTimeout(function() {
            $custom_loader.removeClass('active');
          }, 20000);
        } else {
          $(window).unload(function () {
            setTimeout(function() {
              $custom_loader.removeClass('active');
            }, 20000);
          });
        }
      } else {
        if (getCurrentUrl.pathname == '/') {
          setTimeout(function() {
            $custom_loader.removeClass('active');
          }, 20000);
        
      }
    }

      if (callback) {
        callback(response, param);
      }
    },
    error: function (errorResponse) {
      $('body, .overlay.loading, .custom-loader').removeClass('active');
      console.log('Error in AJAX request');
      if (errorCallback) {
        errorCallback(errorResponse);
      }
    },
  });
}



// WEBPACK FOOTER //
// ./scripts/exports/ajax_load_more.js